import React, { useState } from 'react';
import CreateForm from './CreateForm';
import CustomDialog from '../ui/CustomDialog';

const HeaderSection = (props) => {

  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="row" style={{marginBottom: "10px" }}>
        <div className="col-lg-12">
          <button type="button" className="btn btn-primary float-end" onClick={ e => setOpen(true) } >Add New Page</button>
        </div>
      </div>

      <CustomDialog maxWidth="md" title="Add New Page" open={open} setOpen={setOpen} >
        <CreateForm
          session={props.session}
          setOpen={setOpen}
          filterInput={props.filterInput}
        />
      </CustomDialog>

    </>
  );
}

export default HeaderSection;
